import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PageComponent from '../components/page-component'

const IndexPage = () => {
  const { metadata, links } = useStaticQuery(graphql`
    query {
      links: markdownRemark(frontmatter: { key: { eq: "links" } }) {
        frontmatter {
          data {
            label
            url
          }
        }
      }
      metadata: contentYaml {
        title
        description
        lang
        logo {
          childImageSharp {
            fluid(maxWidth: 320, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
  `)
  return (
    <PageComponent
      description={metadata.description}
      lang={metadata.lang}
      links={links.frontmatter.data}
      logo={metadata.logo}
      title={metadata.title}
    />
  )
}

export default IndexPage
